import { Route } from 'routes/types/Route'

import CheckupLogDetails from './pages/CheckupLogDetails'
import CheckupLogsList from './pages/CheckupLogs'
import { PropertyCreateForm, PropertyEditForm } from './pages/PropertyForm'

const routes: Route[] = [
  { path: '/admin/logs/:checkupId/:tabKey?', component: CheckupLogDetails, layout: 'admin' },
  { path: '/admin/logs', component: CheckupLogsList, layout: 'admin' },
  { path: '/admin/properties/add', component: PropertyCreateForm, layout: 'admin' },
  { path: '/admin/properties/:hotelId', component: PropertyEditForm, layout: 'admin' },
]

export default routes
